// src/app/reducers/customer.reducer.ts
import { Action, createReducer, on } from '@ngrx/store';
import {
  taxIsCreatedAction,
  removeRecentTaxAction,
  restrictCreateTaxToOutputTaxAction
} from 'src/app/actions/tax';
import { TaxApiResponse } from 'src/app/shared/types/tax';

export interface taxState {
  taxes: TaxApiResponse['data'][];
  recentTax?: TaxApiResponse['data'] | null;
  restrictCreateTaxToOutputTax: boolean;
}

export const initialState: taxState = {
  taxes: [],
  recentTax: undefined,
  restrictCreateTaxToOutputTax: false
};

const _taxReducer = createReducer(
  initialState,
  on(taxIsCreatedAction, (state, { newTax }) => ({
    ...state,
    taxes: [...state.taxes, newTax],
    recentTax: newTax
  })),
  on(removeRecentTaxAction, state => ({
    ...state,
    recentTax: null
  })),
  on(restrictCreateTaxToOutputTaxAction, (state, { restrict }) => ({
    ...state,
    restrictCreateTaxToOutputTax: restrict
  }))
);

export function taxReducer(state: taxState | undefined, action: Action) {
  return _taxReducer(state, action);
}
